import { Button, Tooltip } from 'antd'
import React, { FunctionComponent, useMemo } from 'react'

import { DRAWER_VIEW, resetDrawerView } from '../../../redux/drawerSlice'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { AuctionMonitoringLinkedPropertyHelpModalButton } from '../AuctionMonitoringLinkedPropertyHelpModalButton/AuctionMonitoringLinkedPropertyHelpModalButton'

export interface AuctionDrawerPropertyHeaderProps {
  auctionUrl?: string
}

const styles = { body: { width: 'min-content' } }

export const AuctionDrawerPropertyHeader: FunctionComponent<AuctionDrawerPropertyHeaderProps> =
  ({ auctionUrl }) => {
    const isAssigmentMode =
      useAppSelector(state => state.drawer?.viewType) ===
      DRAWER_VIEW.ASSIGNMENT_MODE

    const dispatch = useAppDispatch()

    const tooltipTitle = useMemo(
      () => (
        <div className="space-y-2">
          <div>
            Pokud chcete panel zavřít, vypněte prvně řežim přiřazování
            nemovitostí k dražbě.
          </div>
          <div className="flex items-center justify-between">
            <AuctionMonitoringLinkedPropertyHelpModalButton
              defaultActiveKey="map"
              buttonText="Nápověda"
            />
            <Button
              icon={<span className="text-lg -mt-1 mr-2">×</span>}
              onClick={() => dispatch(resetDrawerView())}
              type="link"
              ghost
            >
              Vypnout režim
            </Button>
          </div>
        </div>
      ),
      [dispatch]
    )

    if (!auctionUrl) {
      return null
    }

    if (isAssigmentMode) {
      return (
        <Tooltip
          title={tooltipTitle}
          zIndex={1110}
          className="flex items-center w-m"
          styles={styles}
        >
          <div className="text-gray-400 font-normal text-base space-x-2">
            <span className="inline-block h-2.5 w-2.5 rounded-full border border-primaryHover bg-primaryHover/20 animate-pulse" />
            <span>Přiřazování nemovitostí k dražbě...</span>
          </div>
        </Tooltip>
      )
    }

    return (
      <div className="flex justify-between items-center">
        <div>Náhled dražby</div>
        <Button
          href={auctionUrl}
          target="_blank"
          title="Přejít na dražbu v novém okně"
          rel="noreferrer"
          type="primary"
        >
          Přejít na dražbu
        </Button>
      </div>
    )
  }
